import '@src/bootstrap';
import MainLayout  from './layouts/main-page.vue';
import router      from './routes/main-page';
import store       from '../../store';
import VeeValidate from 'vee-validate';
import Toaster from 'v-toaster';
import Vue from 'vue';
import VueLazyImageLoading from 'vue-lazy-image-loading';
import infiniteScroll from 'vue-infinite-scroll';
import PreLoader from '../../components/pre-loader';

import '../../../assets/scss/toaster.scss';
import VModal from 'vue-js-modal';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

Vue.use(VueMoment, {moment});
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VeeValidate);

Vue.use(Toaster, {timeout: 5000});
Vue.use(infiniteScroll);
Vue.component('pre-loader', PreLoader);
Vue.use(VueLazyImageLoading, {
  placeholder: '../../../vue-app/assets/img/loader-black.svg',
  blur: 0,
  position: 'center',
  repeat: 'no-repeat'
});

new Vue({
	el : '#products',
	router,
	store,
	render : h => h(MainLayout)
}).$mount('#app');
